module.exports = __webpack_public_path__ + "static/product.jygy-953e6c2a2d66a668889fdd34b62eddc9.png";